import React from "react";
import PropTypes from "prop-types";
import * as types from "../../../constants/ComponentConstants";
import Section from "../../common/Section";
import Form from "../../common/Form";
import Row from "../../common/Row";
import TextInput from "../../common/TextInput";
import AutoComplete from "../../common/AutoComplete";
import Button from "../../common/Button";
import SelectInput from "../../common/SelectInput";
import InfrastructuurAddFormTable from "./InfrastructuurAddFormTable";
import Tooltip from "../../common/Tooltip";

const AddInfrastructurenForm = (props) => {
    const {
        models,
        onChange,
        onCancel,
        onContinue,
        onSearch,
        naamFilter,
        locatieFilter,
        sporttakFilter,
        aardFilter,
        locaties,
        sporttakken,
        aarden,
        zoekModels,
        totaalAantalZoekResultaten,
        onAddNew,
        nieuweInfrastructuren,
        somethingChanged,
        nameFilterHasFocus
    } = props;

    const heeftFilter = !!naamFilter || !!locatieFilter || !!sporttakFilter || !!aardFilter;

    const buttonContent = <div>Nieuwe sportinfrastructuur toevoegen<Tooltip windowWidth={45} tooltipColor={types.COLOR_WHITE} iconColor={types.COLOR_WHITE} text="Voeg een sportinfrastructuur toe indien je deze niet terug vindt in de zoekresultaten" /></div>;

    return (
        <Section
            title={"Infrastructuren toevoegen"}
            color={types.COLOR_RED}
        >
            <Form name="infrastructuren toevoegen"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Ga verder"
                onRightButtonClick={onContinue}
                leftButtonLabel="Annuleer"
                onLeftButtonClick={onCancel}
            >
                <Section>
                    <Row>
                        <div className="o-col-10">Geef één of meerdere zoekcriteria in om een infrastructuur te zoeken in onze sportinfrastructuurdatabank.</div>
                    </Row>
                    <br />
                    <Row>
                        <TextInput
                            name="naamFilter"
                            label="Naam"
                            value={naamFilter}
                            size={6}
                            onChange={onChange}
                            hasFocus={nameFilterHasFocus}
                        />
                        <AutoComplete
                            minSearchLength={1}
                            items={locaties}
                            size={6}
                            name="locatieFilter"
                            label="Postcode - Gemeente"
                            value={locatieFilter}
                            onChange={onChange}
                            useDefaultItem={false}
                            clearable
                        />
                    </Row>
                    <Row>
                        <AutoComplete
                            minSearchLength={1}
                            items={sporttakken}
                            size={6}
                            name="sporttakFilter"
                            label="Sporttak"
                            value={sporttakFilter}
                            onChange={onChange}
                            useDefaultItem={false}
                            clearable
                        />
                        <SelectInput
                            name="aardFilter"
                            label="Soort"
                            value={aardFilter}
                            size={6}
                            items={aarden}
                            onChange={onChange} />

                    </Row>
                    <Row>
                        <Button style={{ marginLeft: '.83333%', paddingLeft: '1.1em' }} onClick={onSearch} text="Zoek" className="o-col-1" disabled={!heeftFilter} />
                        <p className="o-col-6">&nbsp;</p>
                        <Button style={{ width: "33.5%", float: 'right', marginRight: '.83333%' }} onClick={onAddNew} className="o-col-5" children={buttonContent} disabled={nieuweInfrastructuren || somethingChanged} />
                    </Row>
                </Section>
                <Section>
                    <InfrastructuurAddFormTable infrastructuren={models} zoekModels={zoekModels} onChange={onChange} heeftFilter={heeftFilter} totaalAantalZoekResultaten={totaalAantalZoekResultaten} />
                </Section>
            </Form>
        </Section>
    );
};

AddInfrastructurenForm.propTypes = {
    models: PropTypes.array,
    onChange: PropTypes.func,
    onCancel: PropTypes.func,
    onContinue: PropTypes.func,
    onSearch: PropTypes.func,
    naamFilter: PropTypes.string,
    locatieFilter: PropTypes.string,
    sporttakFilter: PropTypes.string,
    aardFilter: PropTypes.string,
    locaties: PropTypes.array,
    sporttakken: PropTypes.array,
    aarden: PropTypes.array,
    zoekModels: PropTypes.array,
    totaalAantalZoekResultaten: PropTypes.number,
    onAddNew: PropTypes.func,
    nieuweInfrastructuren: PropTypes.string,
    somethingChanged: PropTypes.bool,
    nameFilterHasFocus: PropTypes.bool
};

export default AddInfrastructurenForm;